import request from '@/utils/request'

/**
 * 获取保养项目
 * @param {*} data
 */
function maintenanceItem(data) {
    return request({
      url: '/maintainItem/list',
      method: 'post',
      data
    })
  }
/**
 * 新增保养项目maintenance
 * @param {*} data
 */
  function createMaintenance(data) {
    return request({
      url: '/maintainItem/create',
      method: 'post',
      data
    })
  }

  /**
 * 修改保养项目
 * @param {*} data
 */
  
  function updateMaintenance(obj) {
    return request({
      url: `/maintainItem/${obj.id}`,
      method: 'PUT',
      data: obj.data
    })
  }

  /**
 * 删除保养
 * @param {*} data 
 */
function deleteMaintenance(id){
  return request({
    url: `/maintainItem/${id}`,
    method: 'DELETE'
  })
}
  export {
    maintenanceItem,
    createMaintenance,
    updateMaintenance,
    deleteMaintenance
  }